import { motion } from 'framer-motion';
import { Mail, Send, CheckCircle2, User } from 'lucide-react';

const recipients = [
  { name: 'Ahmed Al Rashid', role: 'Organization Owner', email: 'ahmed.rashid@alnoor.ae', eid: '784-1234-5678901-1' },
  { name: 'Fatima Al Maktoum', role: 'Facility Manager', email: 'fatima.m@alnoor.ae', eid: '784-9876-5432101-2' },
  { name: 'Dr. Hassan Ali', role: 'Medical Director', email: 'h.ali@alnoor.ae', eid: '784-5566-7788991-3' },
];

function EnvelopeAnimation({ recipient, index }) {
  const delay = 0.6 + index * 0.5;

  return (
    <motion.div
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="flex items-center gap-4 bg-white rounded-2xl border border-black/5 shadow-lg p-5"
    >
      <div className="w-12 h-12 rounded-xl bg-teal-600/10 flex items-center justify-center flex-shrink-0">
        <User size={22} className="text-teal-700" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-heading font-bold text-[#0A0A0A] text-sm">{recipient.name}</p>
        <p className="font-body text-xs text-[#737373]">{recipient.role}</p>
        <p className="font-body text-xs text-[#737373] mt-0.5">{recipient.email}</p>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.5, x: -20 }}
        animate={{ opacity: 1, scale: 1, x: 0 }}
        transition={{ delay: delay + 0.3, duration: 0.4 }}
        className="flex items-center gap-2"
      >
        <motion.div
          initial={{ x: 0 }}
          animate={{ x: [0, 8, 0] }}
          transition={{ delay: delay + 0.5, duration: 0.6, ease: 'easeInOut' }}
        >
          <Mail size={18} className="text-teal-600" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: delay + 0.9 }}
        >
          <CheckCircle2 size={18} className="text-emerald-500" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default function InvitesScene() {
  return (
    <div data-testid="scene-invites" className="flex flex-col items-center justify-center h-full px-8">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="w-full max-w-3xl"
      >
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-10"
        >
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-4">
            <Send size={14} /> Step 3
          </span>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight text-[#0A0A0A]">
            Dispatch Invites
          </h2>
          <p className="mt-3 font-body text-lg text-[#737373]">
            Email invitations sent to associated end users
          </p>
        </motion.div>

        <div className="space-y-4">
          {recipients.map((r, i) => (
            <EnvelopeAnimation key={r.email} recipient={r} index={i} />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2.5 }}
          className="mt-8 text-center"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50 border border-emerald-200">
            <CheckCircle2 size={16} className="text-emerald-600" />
            <span className="font-body text-sm font-medium text-emerald-700">
              3 invites sent successfully
            </span>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
